import { Component, Input, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import '@cigna/leaf-web/lib/wc/components/progress-steps/progress-steps';

@Component({
  selector: 'cigna-leaf-progress-steps',
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  template: `
    <leaf-progress-steps
      [layout]="layout"
      [ariaLabel]="ariaLabel"
      [totalSteps]="totalSteps"
    >
      <ng-content></ng-content>
    </leaf-progress-steps>
  `,
})
export class CignaLeafProgressStepsComponent {
  // todo: replace with import types once this bug is fixed https://github.com/cigna-group/leaf-web/issues/323
  @Input() layout: 'vertical' | 'horizontal';
  @Input() ariaLabel: string;
  @Input() totalSteps: number;
}
